<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.28066 1.43201L1.43213 2.28053L4.17071 5.01914C3.21555 5.54579 2.56812 6.56547 2.56812 7.73702V17.5401C2.56812 19.2513 3.94945 20.6385 5.65342 20.6385H14.5726C15.9834 20.6385 17.173 19.6876 17.5406 18.3892L21.7194 22.568L22.5679 21.7195L2.28066 1.43201ZM16.4238 17.2724L5.11067 5.95912C4.35313 6.19207 3.80224 6.89994 3.80224 7.73702V17.5401C3.80224 18.5668 4.63104 19.3992 5.65342 19.3992H14.5726C15.595 19.3992 16.4238 18.5668 16.4238 17.5401V17.2724Z"
      :class="colorClass"
    />

    <path
      d="M16.4238 7.73702V13.9907L17.6597 15.2265L17.6598 9.88682L21.3338 7.82383C21.3338 11.6013 21.3338 15.3787 21.3338 19.1562C21.8508 19.1298 22.5679 18.7065 22.5679 18.1231L22.5679 7.47167C22.5679 6.68291 21.7231 6.18526 21.0375 6.57019L17.6579 8.46788V7.73702C17.6579 6.02578 16.2766 4.63855 14.5726 4.63855H7.07178L8.31116 5.87794H14.5726C15.595 5.87794 16.4238 6.71028 16.4238 7.73702Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
